export const testimonials = [
  {
    quote: 'Spolupráca s nexify-studio.tech zmenila náš pohľad na to, čo je možné. Za 3 mesiace sme mali funkčnú AI platformu.',
    name: 'Ing. Martin Kováč',
    role: 'CTO',
    company: 'DataFlow SK',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=96&h=96&fit=crop&crop=face',
  },
  {
    quote: 'PWA riešenie nám ušetrilo 40 % nákladov na mobilnú aplikáciu. Kvalita je na úrovni natívnych appiek.',
    name: 'Mgr. Zuzana Horváthová',
    role: 'CEO',
    company: 'MedTech Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=96&h=96&fit=crop&crop=face',
  },
  {
    quote: 'Gemini embeddings v našom systéme zvýšili presnosť vyhľadávania o 85 %. Neuveriteľné výsledky.',
    name: 'Bc. Peter Novák',
    role: 'Head of AI',
    company: 'LogiSmart',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=96&h=96&fit=crop&crop=face',
  },
]
